import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { FacetItemDto } from './facet-item-dto.type';

const FacetResponse = t.type(
  {
    name: t.string,
    fieldName: t.string,
    items: nullable(t.array(FacetItemDto)),
  },
  'SearchRequest',
);

type FacetResponse = t.TypeOf<typeof FacetResponse>;
export { FacetResponse };
